export default "__VITE_ASSET__44c85ae1__"